var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnchorClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.5795L1.77275 0.352251C1.66726 0.246762 1.52418 0.187499 1.375 0.187499C1.22582 0.187499 1.08274 0.246762 0.977253 0.352251C0.871764 0.457741 0.812501 0.600815 0.812501 0.749999C0.812501 0.899183 0.871764 1.04226 0.977253 1.14775L6.60225 6.77275C6.70774 6.87824 6.85082 6.9375 7 6.9375C7.14918 6.9375 7.29226 6.87824 7.39775 6.77275L13.0225 1.14796L13.0227 1.14775C13.1282 1.04226 13.1875 0.899184 13.1875 0.75C13.1875 0.600816 13.1282 0.457742 13.0227 0.352252C12.9173 0.246763 12.7742 0.1875 12.625 0.1875C12.4758 0.1875 12.3327 0.246763 12.2273 0.352252L12.227 0.352463L7 5.5795Z",
    fill: "#838383"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnchorClose);
export default __webpack_public_path__ + "static/media/anchorClose.fc5f5cfbf9dd7a7cd0b546e1ade267d4.svg";
export { ForwardRef as ReactComponent };